import mermaid from 'mermaid'

mermaid.initialize({
  startOnLoad:false,
  securityLevel: 'strict',
  theme: 'forest',
  fontFamily: '"Arial", "Helvetica", sans-serif',
  flowchart: {
    useMaxWidth: true
  },
  sequence: {
   useMaxWidth: true
  },
  state: {
    useMaxWidth: true
  },
  git: {
    useMaxWidth: true
  },
  class: {
    useMaxWidth: true
  },
  gantt: {
    axisFormat: '%d.%m.%Y'
  }
})
